import api from '@/services/api';

/**
 * Resolve Frappe file paths for <img src>.
 * On Electron (absolute API base like https://host/api), `/files/...` must use the API origin.
 * On web (relative `/api`), keep rooted paths so Vite proxy / same-origin work.
 */
export function resolveFileUrl(url?: string | null): string {
  if (!url) return '';
  if (/^https?:\/\//i.test(url) || url.startsWith('data:') || url.startsWith('blob:')) {
    return url;
  }
  if (url.startsWith('/')) {
    const base = String(api.defaults.baseURL || import.meta.env.VITE_API_URL || '');
    if (/^https?:\/\//i.test(base)) {
      const origin = base.replace(/\/api\/?$/, '');
      return origin + url;
    }
    return url;
  }
  return url;
}
